import styled from 'styled-components/macro'

export const StyledWrap = styled.div<{ gridArea?: string }>`
  grid-area: ${(props) => props.gridArea};
`
